
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTable, useSortBy, usePagination, useFilters } from "react-table";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const ArchiveTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/categories`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
  }, []);

  const columns = React.useMemo(
    () => [
      { Header: "Number", accessor: (row, index) => index + 1 },
      { Header: "Title", accessor: "title" },
      { Header: "Description", accessor: "description" },
      { Header: "Published Date", accessor: "published_at" },
      {
        Header: "Action",
        Cell: ({ row }) => (
          // <Link
          //   to={`/details/${row.original.id}`}
          //   className='text-blue-500 hover:underline'
          // >
          //   Details
          // </Link>
          <Link
      to={`/categoryDetails/${row.original.id}`} // Ensure correct path and ID
      className='text-blue-500 hover:underline'
    >
      Details
    </Link>
        ),
      },
    ],
    []
  );

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredData = React.useMemo(() => {
    if (searchTerm === "") {
      return data;
    } else {
      return data.filter((item) => {
        return item.title.toLowerCase().includes(searchTerm.toLowerCase());
      });
    }
  }, [data, searchTerm]);

  const sortedData = React.useMemo(() => {
    if (sortOrder === "asc") {
      return filteredData.sort((a, b) => a.title.localeCompare(b.title));
    } else {
      return filteredData.sort((a, b) => b.title.localeCompare(a.title));
    }
  }, [filteredData, sortOrder]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data: sortedData,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useFilters,
    useSortBy,
    usePagination
  );

  return (
    <>
      <Navbar />
      {/* Search and Sort UI */}
      <div className='justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8'>
        <table className='w-full table-auto'>
          <input
            type='text'
            placeholder='Search by title'
            onChange={handleSearchChange}
            className='px-4 py-2 text-base border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 w-64'
          />
        </table>
      </div>

      {/* Table UI */}
      <div className='w-full text-black bg-gray-100 shadow'>
        <div className='justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8'>
          <table {...getTableProps()} className='w-full table-auto'>
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()} className='text-sm leading-normal text-gray-100 uppercase bg-gray-600'>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps(column.getSortByToggleProps())} className='px-6 py-3 text-left'>
                      {column.render("Header")}
                      <span>{column.isSorted ? (column.isSortedDesc ? " ▼" : " ▲") : ""}</span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()} className='text-sm font-light text-gray-600'>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} className='hover:bg-gray-100'>
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()} className='px-6 py-3 border'>
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Pagination UI */}
        <div className='w-full text-black bg-gray-100 shadow'>
          <div className='justify-between px-4 mx-auto lg:max-w-7xl md:items-center md:flex md:px-8'>
            <div className='flex items-center justify-between mt-4'>
              <div>
                <button onClick={() => previousPage()} disabled={!canPreviousPage} className='px-2 py-1 mr-2 text-sm font-medium text-black bg-blue-500 rounded disabled:opacity-50'>Previous</button>
                <button onClick={() => nextPage()} disabled={!canNextPage} className='px-2 py-1 text-sm font-medium text-black bg-blue-500 rounded disabled:opacity-50'>Next</button>
              </div>
              <div>
                <span className='ml-16 text-sm font-medium text-gray-600'>Page {pageIndex + 1} of {pageOptions.length}</span>
                <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))} className='px-2 py-1 ml-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded'>
                  {[10, 20, 30, 40, 50].map((size) => (
                    <option key={size} value={size}>{size}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ArchiveTable;
